import {
    FETCH_RATER_HEATMAP_START,
    FETCH_RATER_HEATMAP_SUCCESS,
    FETCH_RATER_HEATMAP_FAIL,

} from "../../../constants";
import {
    FETCH_RATER_HEATMAP_URL,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';

export const getRaterHeatmap = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(FETCH_RATER_HEATMAP_START, { ...payload })
        );
        return apiBaseInstance
            .post(FETCH_RATER_HEATMAP_URL, {
                benchmarkFilters: payload, ...getProjectIdAndOrgId(payload)
            })
            .then((res) => {
                dispatch(
                    withType(FETCH_RATER_HEATMAP_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb()
            })
            .catch((err) => {
                dispatch(withType(FETCH_RATER_HEATMAP_FAIL, { ...err, ...payload }));
                cb && cb()
            });
    };
};

